import React from 'react';

const information = () => (
    <section className='information-component'>
        <h1>What is a Pomodoro Timer?</h1>
        <p>
            The Pomodoro Timer is a productivity tool based on the Pomodoro Technique, 
            which encourages focused work sessions followed by short breaks.
        </p>

        <h2>How It Works</h2>
        <p>Set a task and start a 25-minute work session.</p>
        <p>Take a 5-minute break after each session.</p>
        <p>After 4 sessions, take a longer break to recharge.</p>

        <h2>Features</h2>
        <p>Customizable work, short break, and long break durations.</p>
        <p>Ability to track tasks and select what you are working on</p>
        <p>Sound alerts to notify when time is up.</p>

        <h2>Tips for Best Results</h2>
        <p>
            Stay focused during work sessions, avoid multitasking, and fully relax during breaks. Consistency with the timer will help improve productivity over time!
        </p>
    </section>
);

export default information